<template>
  <VisaForm country="cambodia" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <ClientFields v-model="form.client" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>
    
    <template #details="{ form }">
      <EntryFields v-model="form.entry" has-port />
      <AppRow>
        <StayAddress v-model="form.stayAddress" />
      </AppRow>
      <PassportDetailsNotes half-year-valid />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
          <OccupationStatus v-model="applicant.occupationStatus" />
        </template>
      </ApplicantInfo>
    </template>
    
    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>